export default "__VITE_ASSET__BuQO$7fP__"